import React from 'react'
import RichText from '@/components/richText'

import { Width } from '../Width'
import type { DefaultTypedEditorState } from '@payloadcms/richtext-lexical'

export const Message: React.FC<{ message: DefaultTypedEditorState }> = ({ message }) => {
  return (
    <Width className='my-3' width='100'>
      {message && <RichText data={message} />}
    </Width>
  )
}
